module.exports = __webpack_public_path__ + "img/黄色背景图1.886f958a.jpg";